export const BOOKING_STATUS_UNAPPROVED = 1;
export const BOOKING_STATUS_APPROVED = 2;
export const BOOKING_STATUS_CHECKED_OUT = 3;
export const BOOKING_STATUS_CHECKED_IN = 4;
export const BOOKING_STATUS_CANCELLED = 5;
export const EDIT_BOOKING_TIME_CLICKED = 6;



// WEBPACK FOOTER //
// ./scripts/constants/booking.js